// extracted by mini-css-extract-plugin
module.exports = {"root":"_22Tvb","categoryRoot":"_1YyrM","category":"_2vsaM","servicesRoot":"_2dtcQ","service":"s_I7s"};